import { SupabaseServiceView } from "../../../server/supabase/base-supabase-service";

import type { Database } from "../../../__definitions__/database-definitions";

export type OutboxRecipient = Database["public"]["Views"]["outbox_recipients"]["Row"];

export class SupabaseOutboxRecipientsService extends SupabaseServiceView<"outbox_recipients"> {
  table = "outbox_recipients" as const;
}
